let currentPositionPromise = null;

const GEOLOCATION_OPTIONS = {
  enableHighAccuracy: true,
  timeout: 10000,
  maximumAge: 60000,
};

export const requestCurrentPosition = () => {
  if (!navigator.geolocation) {
    return Promise.reject(new Error("GEOLOCATION_UNAVAILABLE"));
  }

  if (!currentPositionPromise) {
    currentPositionPromise = new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        resolve,
        reject,
        GEOLOCATION_OPTIONS,
      );
    }).catch((error) => {
      // Allow a later retry after a timeout, a temporary error or a permission
      // change made from the browser settings.
      currentPositionPromise = null;
      throw error;
    });
  }

  return currentPositionPromise;
};

export const resetCurrentPositionRequest = () => {
  currentPositionPromise = null;
};
